import posthog from 'posthog-js';

// Event name constants
export enum AnalyticsEvent {
  // Company Events
  COMPANY_INVITE_SEND_EVENT = 'company_invite_send_clicked',

  // Access Events
  ACCESS_EDIT_EVENT = 'access_edit_clicked',

  // Pricing Events
  PRICING_EDIT_EVENT = 'pricing_rule_edit_save_clicked',

  // Report Events
  REPORT_GENERATE_EVENT = 'report_generate_clicked',

  // Spark session history inline banner (charger detail)
  SPARK_SESSION_BANNER_VIEWED = 'spark_session_banner_viewed',
  SPARK_SESSION_BANNER_LEARN_MORE_CLICKED = 'spark_session_banner_learn_more_clicked',
  SPARK_SESSION_BANNER_DISMISSED = 'spark_session_banner_dismissed',

  // Charger Events
  CHARGER_ADD_EVENT = 'charger_add_save_clicked',
  CHARGER_REBOOT_EVENT = 'charger_reboot_clicked',
  CHARGER_MOVE_EVENT = 'charger_move_confirm_clicked',
  CHARGER_DETAILS_UPDATE_EVENT = 'charger_details_save_clicked',
  CHARGER_DETAILS_UPDATE_CANCELLED_EVENT = 'charger_details_cancel_clicked',

  // Discount Events
  DISCOUNT_ADD_EVENT = 'discount_add_save_clicked',

  // Payout Events
  PAYOUT_EXPORT_EVENT = 'payout_export_clicked',

  // License Events
  LICENSE_GENERATE_EVENT = 'license_generate_save_clicked',
  LICENSE_ALIGNMENT_EVENT = 'license_align_clicked',

  // Self-Serve Company creation events
  SELF_SERVE_COMPANY_CREATION_PAGE_ARRIVED = 'self_serve_company_creation_page_arrived',
  SELF_SERVE_COMPANY_CREATION_STARTED = 'self_serve_company_creation_started',
  SELF_SERVE_COMPANY_CREATION_SUCCESS = 'self_serve_company_creation_success',
  SELF_SERVE_COMPANY_CREATION_ERROR = 'self_serve_company_creation_error',

  // MFA events
  MFA_CODE_VERIFICATION_STARTED = 'mfa_code_verification_started',
  MFA_CODE_VERIFICATION_SUCCESS = 'mfa_code_verification_success',
  MFA_CODE_VERIFICATION_ERROR = 'mfa_code_verification_error',
  MFA_CODE_RESEND = 'mfa_code_resend',

  // Sign up events
  SIGNUP_PAGE_ARRIVED = 'signup_page_arrived',
  ACCOUNT_CREATION_STARTED = 'account_creation_started',
  ACCOUNT_CREATION_SUCCESS = 'account_creation_success',
  ACCOUNT_CREATION_ERROR = 'account_creation_error',

  // Data Table Events
  DATA_TABLE_EXPORT_AS_CSV_EVENT = 'data_table_export_as_csv_clicked',
  DATA_TABLE_SORT_COLUMN_EVENT = 'data_table_sort_column_clicked',
}

// Type for properties that can be passed with events
export type AnalyticsProperties = {
  [key: string]: string | number | boolean | null | undefined;
};

// Main analytics capture function
export const captureAnalyticsEvent = (
  event: AnalyticsEvent,
  properties?: AnalyticsProperties,
): void => {
  try {
    posthog.capture(event, properties);
  } catch (error) {
    console.error(`Failed to capture analytics event: ${event}`, error);
  }
};
